import React from "react";
import { useTheme } from "@mui/material";

export const TooltipIcon = () => {
  const { palette } = useTheme();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="8"
        cy="8"
        r="7.5"
        stroke={palette.divider}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.02997 4.18919C7.92554 4.18919 7.84078 4.27395 7.84154 4.37838C7.84154 4.48281 7.92629 4.56757 8.03072 4.56757C8.13516 4.56757 8.21991 4.48281 8.21991 4.37838C8.21991 4.27395 8.13516 4.18919 8.02997 4.18919"
        stroke={palette.text.secondary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8L8 12"
        stroke={palette.text.secondary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
